import { render } from "./BulkUploadStatusItem.vue?vue&type=template&id=19768c32&ts=true"
import script from "./BulkUploadStatusItem.vue?vue&type=script&lang=ts"
export * from "./BulkUploadStatusItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__